(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login-react/assets/react/pages/bankid/components/bankid-waiting.js') >= 0) return;  svs.modules.push('/modules/player-login-react/assets/react/pages/bankid/components/bankid-waiting.js');

'use strict';

const {
  logger
} = svs.playerLoginReact;
const {
  ReactButton: Button
} = svs.ui;
const {
  useHistory
} = ReactRouterDOM;
const {
  Loader
} = svs.components.ReactLoader;
const {
  bankidProgressStatus,
  bankIdErrorCodes,
  appWaitStatus,
  route
} = svs.playerLoginReact.constants;
const {
  bankIdBackendStatus,
  setIsBankidOnThisDeviceDesktop
} = svs.playerLoginReact.store.playerloginreactactions;
const useBankIdPollStatus = svs.playerLoginReact.bankid.useBankIdPollStatus;
const Bank = svs.ui.ReactBank;
const {
  useUrlHelper,
  SelectEidMenu,
  LoginQrCode,
  AriaCountdownTimer
} = svs.playerLoginReact.sharedComponents;

const BankIdWaiting = _ref => {
  let {
    isLogin = true,
    bankIdPollWait = appWaitStatus.WAITING_QRCODE,
    preFetchedAst = null
  } = _ref;
  const dispatch = ReactRedux.useDispatch();

  const bankIdAutoStartToken = ReactRedux.useSelector(state => state.playerloginreact.autoStartToken);
  const isStandardMobile = ReactRedux.useSelector(state => state.playerloginreact.isStandardMobile);
  const baseUrl = ReactRedux.useSelector(state => state.playerloginreact.baseUrl);
  const history = useHistory();
  const isQrCode = bankIdPollWait === appWaitStatus.WAITING_QRCODE;
  const {
    appUrl,
    qrCode,
    backendStatus,
    cancelBackendPoll,
    isLastQrRetry,
    backendError
  } = useBankIdPollStatus(isQrCode, isLogin, bankIdAutoStartToken || preFetchedAst);
  const [waitStatus, setWaitStatus] = React.useState(bankidProgressStatus.BEFORE_POLL);
  const [shouldShowScanText, setShouldShowScanText] = React.useState(true);
  const {
    navigateToCancelUrl
  } = useUrlHelper();
  const isBankidOnThisDeviceDesktop = ReactRedux.useSelector(state => state.playerloginreact.isBankidOnThisDeviceDesktop);

  React.useEffect(() => {
    dispatch(bankIdBackendStatus(backendStatus));
    setWaitStatus(backendStatus);
  }, [backendStatus]);
  React.useEffect(() => {
    if (appUrl && appUrl.length > 5 && bankIdPollWait === appWaitStatus.WAITING_APP && !preFetchedAst) {
      logger.debug('**** open appurl:', appUrl);
      svs.utils.url.navigate(appUrl);
    }
  }, [appUrl]);
  React.useEffect(() => {
    if (isLastQrRetry) {
      const btn = document.getElementById('retryButton');
      if (btn) {
        btn.focus();
      }
    }
  }, [isLastQrRetry]);
  const onBankIdThisDeviceClick = async () => {
    dispatch(setIsBankidOnThisDeviceDesktop(true));
    await cancelBackendPoll();
    if (isLogin) {
      history.push(route.LOGIN_BANKID_POLL_APP_ROUTE);
    } else {
      history.push(route.REGISTRATE_BANKID_POLL_APP_ROUTE);
    }
  };
  const onRetry = async () => {
    await cancelBackendPoll();
    history.push(isLogin ? route.LOGIN_BANKID_START_ROUTE : route.REGISTRATE_BANKID_START_ROUTE);
  };
  const handleTimerDone = React.useCallback(() => {
    setShouldShowScanText(false);
  }, []);
  const onCancelClick = async () => {
    await cancelBackendPoll();
    if (!isBankidOnThisDeviceDesktop && !isStandardMobile) {
      navigateToCancelUrl();
    } else {
      dispatch(setIsBankidOnThisDeviceDesktop(false));
      if (isStandardMobile) {
        logger.debug("**** Doing hard load of ".concat(isLogin ? 'login' : 'registrate'));
        if (isLogin) {
          svs.utils.url.navigate(baseUrl + route.LOGIN_BANKID_START_ROUTE);
        } else {
          svs.utils.url.navigate(baseUrl + route.REGISTRATE_BANKID_START_ROUTE);
        }
      } else if (isLogin) {
        history.push(route.LOGIN_BANKID_START_ROUTE);
      } else {
        history.push(route.REGISTRATE_BANKID_START_ROUTE);
      }
    }
  };
  const handleLoginOnOtherDevice = () => {
    svs.components.analytics.trackEvent({
      category: 'Users',
      action: 'Login Mobile Fallback',
      opt_label: 'bankid'
    });
    history.push(isLogin ? route.LOGIN_BANKID_POLL_QR_ROUTE : route.REGISTRATE_BANKID_POLL_QR_ROUTE);
  };
  return React.createElement("div", {
    className: "fc-navy"
  }, (waitStatus === bankidProgressStatus.WAITING_APP || waitStatus === bankidProgressStatus.BEFORE_POLL || waitStatus === bankidProgressStatus.ERROR_POLL) &&
  bankIdPollWait === appWaitStatus.WAITING_APP && React.createElement(React.Fragment, null, React.createElement("div", {
    className: "padding-top-4 margin-top-3 margin-bottom-1"
  }, React.createElement("p", null, "F\xF6rs\xF6ker starta BankID-appen")), isStandardMobile && React.createElement("div", null, React.createElement(Button, {
    block: true,
    className: "margin-bottom-1",
    onClick: handleLoginOnOtherDevice,
    size: 300,
    transparent: true
  }, "Logga in p\xE5 en annan enhet"))), (waitStatus === bankidProgressStatus.BEFORE_POLL || waitStatus === bankidProgressStatus.SHOWING_QRCODE || waitStatus === bankidProgressStatus.ERROR_POLL) &&
  bankIdPollWait === appWaitStatus.WAITING_QRCODE && React.createElement(React.Fragment, null, !isStandardMobile && React.createElement(SelectEidMenu, {
    isLogin: isLogin
  }), React.createElement(LoginQrCode, {
    errorMessage: "Inloggningen tog f\xF6r l\xE5ng tid.",
    isError: backendError === bankIdErrorCodes.CUSTOMER_SCAN_TIMEOUT,
    qrCode: qrCode
  }, React.createElement(React.Fragment, null, React.createElement("div", {
    className: "padding-bottom-1"
  }, React.createElement(AriaCountdownTimer, {
    onDone: handleTimerDone,
    startTime: 300
  })), !isStandardMobile && isLastQrRetry && React.createElement(Button, {
    block: true,
    className: "margin-bottom-1",
    id: "retryButton",
    onClick: onRetry,
    tabIndex: 0,
    transparent: true
  }, "F\xF6rl\xE4ng tid")), shouldShowScanText && React.createElement("p", {
    className: "padding-top-1"
  }, "Skanna QR-koden med BankID-appen eller starta BankID p\xE5 den h\xE4r enheten.")), !isStandardMobile && React.createElement("div", {
    className: "margin-top-2 margin-bottom-1"
  }, React.createElement(Button, {
    block: true,
    iconPosition: "left",
    inverted: true,
    onClick: onBankIdThisDeviceClick,
    size: 300
  }, React.createElement(Bank, {
    className: "align-left",
    name: "bankid-neg",
    size: 24
  }), "Starta BankID p\xE5 den h\xE4r enheten"))), (waitStatus === bankidProgressStatus.SHOWING_SPINNER || waitStatus === bankidProgressStatus.NEW_CUSTOMER || waitStatus === bankidProgressStatus.RETAIL_CUSTOMER || waitStatus === bankidProgressStatus.ONLINE_CUSTOMER || waitStatus === bankidProgressStatus.REACTIVATED_CUSTOMER) && React.createElement(React.Fragment, null, React.createElement("div", {
    className: "login-react-margin-top-1 login-react-margin-am-top-8"
  }, waitStatus === bankidProgressStatus.SHOWING_SPINNER ? 'Väntar på identifiering i app' : 'Loggar in...'), React.createElement("div", {
    className: "padding-xs-v-2 padding-am-top-2 login-react-padding-am-bottom-8 margin-am-bottom-4"
  }, React.createElement(Loader, {
    inverted: true,
    size: 300
  }))), React.createElement("div", null, React.createElement(Button, {
    block: true,
    onClick: onCancelClick,
    size: 300,
    transparent: true
  }, "Avbryt")));
};
svs.playerLoginReact.bankid.components.BankIdWaiting = BankIdWaiting;

 })(window);